import { types } from "../../types/types";

const initialState = {
    loading: false,
    stepDiscapacidad: 0,
    solicitudSeleccionada: null,
    solicitudes: [],
};

export const AfiliadoDiscapacidadReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.discapacidadClearReducerAutoG:
            return {
                ...initialState
            }
        case types.changeStepperDiscapacidadAfiliado:
            return {
                ...state,
                stepDiscapacidad: action.payload
            }
        case types.discapacidadSetSolicitudAutoGSeleccionada:
            return {
                ...state,
                solicitudSeleccionada: action.payload,
            };
        case types.discapacidadGetSolicitudesAutoGSuccess:
            return {
                ...state,
                solicitudes: action.payload,
                loading: false,
            };
        case types.discapacidadGetSolicitudesAutoGError:
            return {
                ...state,
                solicitudes: [],
                loading: false,
            };
        case types.discapacidadUpdateTerapiaSolicitudAutoGSeleccionada:
            return {
                ...state,
                solicitudSeleccionada: {
                    ...state.solicitudSeleccionada, 
                    integracionTerapia: action.payload
                },
            };
        case types.discapacidadUpdateTransporteSolicitudAutoGSeleccionada:
            return {
                ...state,
                solicitudSeleccionada: {
                    ...state.solicitudSeleccionada, 
                    integracionTransporte: action.payload
                },
            };
        case types.discapacidadSolicitudesAutoGStartLoading:
            return {
                ...state,
                loading: true,
            };
        case types.discapacidadSolicitudesAutoGFinishLoading:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
};
